import { styled, css } from 'twin.macro';
import { Link } from 'react-router-dom';

export const Container = styled.div(() => [
    css`
        max-width: 900px;
        margin: 0 auto;
        padding: 20px;
        color: #000;
        line-height: 1.6;
    `,
]);

export const PageContainer = styled.div(() => [
    css`
        color: #000;
    `,
]);

export const Title = styled.h1(() => [
    css`
        font-size: 4rem;
        font-weight: 700;
        margin-bottom: 4rem;
        color: #50aeb0;
        text-align: left;
    `,
]);

export const Section = styled.section(() => [
    css`
        margin-bottom: 3rem;
    `,
]);

export const Subtitle = styled.h2(() => [
    css`
        font-size: 2.5rem;
        font-weight: 600;
        margin-bottom: 1rem;
        color: #000;
    `,
]);

export const Paragraph = styled.p(() => [
    css`
        font-size: 1.75rem;
        margin-bottom: 1rem;
    `,
]);

export const List = styled.ul(() => [
    css`
        margin-left: 30px;
        list-style-type: disc;
        font-size: 1.75rem;
        margin-bottom: 1rem;
    `,
]);

export const ListItem = styled.li(() => [
    css`
        margin-bottom: 0.5rem;
    `,
]);

export const LogoContainer = styled.div(() => [
    css`
        text-align: center;
    `,
]);

export const Navbar = styled.div(() => [
    css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 5rem;
        padding-bottom: 1rem;
        border-bottom: 1px solid #ccc;
    `,
]);

export const Brand = styled(Link)(() => [
    css`
        display: flex;
        align-items: center;
        text-decoration: none;

        img {
            height: 3rem;
            margin-right: 0.75rem;
        }

        span {
            font-size: 2rem;
            font-weight: 600;
            color: #333;
            &:hover {
                color: #50aeb0;
            }
        }

        &:hover {
            text-decoration: none;
            color: #50aeb0;
        }
    `,
]);

export const LoginButton = styled(Link)(() => [
    css`
        padding: 0.5rem 1.25rem;
        background-color: #50aeb0;
        color: #fff;
        border-radius: 9999px;
        text-decoration: none;
        font-weight: 600;
        font-size: 1.5rem;
        transition: background-color 0.2s;

        &:hover {
            background-color: #3f989a;
            text-decoration: none;
            color: #fff;
        }
    `,
]);

export const InformationContainer = styled.div(() => [
    css`
        color: #333;
        margin-bottom: 1rem;
    `,
]);

export const Footer = styled.footer(() => [
    css`
        margin-top: 4rem;
        border-top: 1px solid #ccc;
        padding-top: 2rem;
        text-align: center;
    `,
]);
